import React from "react";
import Page from "../components/page/page";

export default function PageRouter() {
  return <Page />;
}
